module.exports = __webpack_public_path__ + "static/media/race-background.9968d2ef.jpg";